/* L&P retargeting quiz (rt): screen graph and state. No DOM, testable in Node. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.LPRT_FLOW = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  /* order = how common each objection is (angle 3 report, 2026-09-06) */
  var OBJ_SELF = ['price', 'photos', 'trust', 'choice'];
  var OBJ_GIFT = ['price', 'photos', 'trust', 'choice', 'fit'];
  var STYLE_TO_MODEL = { dohaGoldLife: 'doha', genevaLife: 'geneva', dubaiLife: 'dubai', monacoLife: 'monaco', sydney: 'sydney' };
  var PROOF_SLOT = { style: 0, moment: 1 };
  var PROGRESS = { who: 10, obj: 22, deep: 36, style: 52, moment: 66, more: 78, short: 86, proc: 94, match: 100, lead: 100, done: 100 };

  function initialState() { return { path: '', objection: '', second: '', model: 'dubai', moment: '' }; }
  function objectionsFor(path) { return (path === 'gift' ? OBJ_GIFT : OBJ_SELF).slice(); }
  function remaining(s) {
    return objectionsFor(s.path).filter(function (k) { return k !== s.objection && k !== s.second; });
  }
  /* the small proof on style/moment always answers an objection the person did NOT pick */
  function proofFor(s, screen) {
    if (!(screen in PROOF_SLOT)) return null;
    var others = objectionsFor(s.path).filter(function (k) { return k !== s.objection; });
    return others[PROOF_SLOT[screen]] || null;
  }
  function next(state, screen, answer) {
    var s = Object.assign({}, state);
    switch (screen) {
      case 'gate': return [s, 'who'];
      case 'who':
        if (answer !== 'self' && answer !== 'gift') throw new Error('who: bad answer ' + answer);
        s.path = answer; return [s, 'obj'];
      case 'obj':
        if (answer === 'none') { s.objection = 'none'; return [s, 'style']; }
        if (objectionsFor(s.path).indexOf(answer) < 0) throw new Error('obj: bad answer ' + answer);
        s.objection = answer; return [s, 'deep'];
      case 'deep': return [s, 'style'];
      case 'style': s.model = STYLE_TO_MODEL[answer] || 'dubai'; return [s, 'moment'];
      case 'moment': s.moment = answer; return [s, s.objection === 'none' ? 'proc' : 'more'];
      case 'more':
        if (answer === 'none') return [s, 'proc'];
        if (remaining(s).indexOf(answer) < 0) throw new Error('more: bad answer ' + answer);
        s.second = answer; return [s, 'short'];
      case 'short': return [s, 'proc'];
      case 'proc': return [s, 'match'];
      case 'match': return [s, 'lead'];
      case 'lead': return [s, 'done'];
    }
    throw new Error('unknown screen ' + screen);
  }
  return { initialState: initialState, objectionsFor: objectionsFor, remaining: remaining,
           proofFor: proofFor, next: next, PROGRESS: PROGRESS, STYLE_TO_MODEL: STYLE_TO_MODEL };
});
